import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import SelectInput from 'components/forms/SelectInput';
import Text from 'components/Text';

import { toI18n } from 'util/i18n';

import { CONTRACTOR, EMPLOYEE } from '../../../constants';

const PacketSelectInput = ({
  jobTaxClassification,
  selectedPacket,
  handlePacketChange,
  numberOfDocumentsInContractorTemplate,
  numberOfDocumentsInEmployeeTemplate,
}) => {
  const contractorPacketOptions = useMemo(
    () => [
      {
        value: CONTRACTOR,
        label: `Contractor Packet (${numberOfDocumentsInContractorTemplate} documents)`,
      },
    ],
    [numberOfDocumentsInContractorTemplate]
  );

  const employeePacketOptions = useMemo(
    () => [
      {
        value: EMPLOYEE,
        label: `Employee Packet (${numberOfDocumentsInEmployeeTemplate} documents)`,
      },
    ],
    [numberOfDocumentsInEmployeeTemplate]
  );

  const packetOptions = useCallback(() => {
    switch (jobTaxClassification) {
      case CONTRACTOR:
        return contractorPacketOptions;
      case EMPLOYEE:
        return employeePacketOptions;
      default:
        return [...contractorPacketOptions, ...employeePacketOptions];
    }
  }, [contractorPacketOptions, employeePacketOptions, jobTaxClassification]);

  return (
    <Box pb32>
      <Box pb8>
        <Text fs14 fw600 i18n="add_team.individual_drawer.new_hire_packet" />
      </Box>
      <Box>
        <SelectInput
          options={packetOptions()}
          searchable={false}
          onChange={handlePacketChange}
          value={selectedPacket}
          placeholder={toI18n('add_team.individual_drawer.packet_placeholder')}
        />
      </Box>
    </Box>
  );
};
PacketSelectInput.propTypes = {
  jobTaxClassification: PropTypes.string,
  selectedPacket: PropTypes.string.isRequired,
  handlePacketChange: PropTypes.func.isRequired,
  numberOfDocumentsInEmployeeTemplate: PropTypes.number.isRequired,
  numberOfDocumentsInContractorTemplate: PropTypes.number.isRequired,
};

export default PacketSelectInput;
